import { ASS_OPEN_FOR_AGE_RANGE } from '@/constants'

const assCssClassMap = {
  12: 'child-ass-bg m12',
  18: 'child-ass-bg m18',
  24: 'child-ass-bg m24',
  42: 'yellow accent-3'
}

export default {
  methods: {
    getAssessmentByAge (age) {
      let availableAss = age
      Object.keys(ASS_OPEN_FOR_AGE_RANGE).sort().forEach(key => {
        const ageMap = ASS_OPEN_FOR_AGE_RANGE[key]
        if (ageMap.min <= age && age <= ageMap.max) {
          availableAss = key
        }
      })

      return availableAss || 12
    },
    getAssessmentCssClassByAge (age) {
      return assCssClassMap[this.getAssessmentByAge(age)]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/AssessmentMixin.js